var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsNewFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "#FFF6EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#FDD9AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7881 11.2107C19.2364 10.1327 20.7635 10.1327 21.2118 11.2107L23.2938 16.2164L28.6979 16.6496C29.8616 16.7429 30.3335 18.1952 29.4468 18.9547L25.3295 22.4817L26.5874 27.7551C26.8583 28.8907 25.6229 29.7883 24.6266 29.1798L19.9999 26.3538L15.3733 29.1798C14.377 29.7883 13.1416 28.8908 13.4125 27.7551L14.6704 22.4817L10.553 18.9547C9.66639 18.1952 10.1383 16.7429 11.302 16.6496L16.7061 16.2164L18.7881 11.2107Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsNewFeature);
export default __webpack_public_path__ + "static/media/icons-new-feature.5d27b8da700aa4a7ff244bc7ad438b14.svg";
export { ForwardRef as ReactComponent };